import * as React from 'react';
import { CheckboxType, CheckboxWidget, CheckboxWidgetProps } from './CheckboxWidget';
import { styled } from '../../theme';

export interface CheckboxLabelWidgetProps extends Omit<CheckboxWidgetProps, 'error'> {
  label: string | JSX.Element;
  className?: any;
  disabled?: boolean;
  type?: CheckboxType;
  error?: string;
}

export const CheckboxLabelWidget: React.FC<CheckboxLabelWidgetProps> = (props) => {
  const { disabled, ...rest } = props;
  return (
    <S.Container disabled={!!props.disabled}>
      <S.LabelCheckbox>
        <S.StyledCheckbox {...rest} error={!!props.error} />
        <S.Label
          onClick={(event) => {
            event.stopPropagation();
            props.onChange(!props.checked);
          }}>
          {props.label}
        </S.Label>
      </S.LabelCheckbox>
      {props.error ? <S.Error>{props.error}</S.Error> : null}
    </S.Container>
  );
};

const BASE_LABEL = 'checkbox-label-widget';
namespace S {
  export const Container = styled.div<{ disabled: boolean }>`
    label: ${BASE_LABEL};
    display: flex;
    flex-direction: column;
    opacity: ${(p) => (p.disabled ? 0.7 : 1)};
    pointer-events: ${(p) => (p.disabled ? 'none' : 'all')};
    color: ${(p) => p.theme.text.primary};
    flex-grow: 1;
  `;

  export const Label = styled.div`
    label: ${BASE_LABEL}__label;
    font-size: 14px;
    cursor: pointer;
    user-select: none;
    padding-left: 8px;
  `;

  export const StyledCheckbox = styled(CheckboxWidget)`
    label: ${BASE_LABEL}__checkbox;
    margin-top: 2px;
    width: 16px;
    height: 16px;
  `;

  export const LabelCheckbox = styled.div`
    label: ${BASE_LABEL}__box;
    display: flex;
  `;

  export const Error = styled.div`
    margin-top: 10px;
    color: ${(p) => p.theme.forms.input.error};
    font-size: 14px;
  `;
}
